// =============================================================================
// PTEL - SinPermisoPanel
// ENLROL DOP-2 (a): el enlace del correo, con una cuenta sin rol de
// administración ni de moderación, dice con qué cuenta se ha entrado, su rol y
// qué hacer, en la misma hoja lateral que los paneles.
// =============================================================================

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { ROLE_LABELS, type UserRole } from '@/types/roles';
import type { Theme } from '@/components/auth/auth.types';
import { getAuthTokens } from '@/components/auth/auth.tokens';

export const TITULO_SIN_PERMISO = 'Este enlace es para administración o moderación';

export interface SinPermisoPanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  theme: Theme;
  correo: string;
  rol: UserRole | null;
  onCambiarCuenta: () => void;
}

export function SinPermisoPanel({
  open, onOpenChange, theme, correo, rol, onCambiarCuenta,
}: SinPermisoPanelProps) {
  const t = getAuthTokens(theme);
  const etiquetaRol = rol ? ROLE_LABELS[rol] : 'sin rol asignado';

  const boton = {
    padding: '8px 14px', borderRadius: '8px', cursor: 'pointer',
    fontSize: '14px', fontWeight: 500,
  } as const;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        data-testid="sin-permiso-panel"
        style={{ background: t.bgCard, color: t.text }}
      >
        <SheetHeader>
          <SheetTitle style={{ color: t.text }}>{TITULO_SIN_PERMISO}</SheetTitle>
          <SheetDescription style={{ color: t.textSecondary }}>
            Has entrado como{' '}
            <strong data-testid="sin-permiso-correo" style={{ color: t.text }}>{correo}</strong>
            {' '}· rol{' '}
            <strong data-testid="sin-permiso-rol" style={{ color: t.text }}>{etiquetaRol}</strong>.
            {' '}Si la solicitud te llegó a otra cuenta, entra con ella.
          </SheetDescription>
        </SheetHeader>
        <div style={{ display: 'flex', gap: '8px', marginTop: '20px', flexWrap: 'wrap' }}>
          <button
            type="button"
            data-testid="sin-permiso-cambiar"
            onClick={onCambiarCuenta}
            style={{ ...boton, background: t.primary, color: t.primaryText, border: 'none' }}
          >
            Cambiar de cuenta
          </button>
          <button
            type="button"
            data-testid="sin-permiso-cerrar"
            onClick={() => onOpenChange(false)}
            style={{ ...boton, background: 'transparent', color: t.text, border: `1px solid ${t.border}` }}
          >
            Cerrar
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
